import { Inject, Pipe, PipeTransform } from '@angular/core';
import { Community } from '@models/communities/community.model';
import { ModelService } from '@services/common/model.service';
import { environment } from '@environments/environment';

@Pipe({ name: 'navbarBD' })
export class NavbarBDPipe implements PipeTransform {
  constructor(
    @Inject('CommunityService')
    public communityService: ModelService<Community>
  ) {}

  transform(value: string, ...args: any[]): any {
    if (
      this.communityService.model?.corporation.id ===
        environment.brookdaleCorpId &&
      value === 'Calendar'
    ) {
      return 'Engagement Worksheet';
    }
    return value;
  }
}
